import SignIn from '&/components/Dialogs/SignInDlg/SinIn';
import SignUp from '&/components/Dialogs/SignUpDlg/SignUp';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './HddSignIn.scss';
export default function HddLogin() {
    const location = useLocation();
    const search = new URLSearchParams(location.search);
    const [signType, setSignType] = useState('signIn');
    console.log('location.search', location.search);
    useEffect(() => {
        console.log('search', search);
        setSignType(search.get('signType'));
    }, []);
    return (
        <div className="hdd-login-wrap signInAndSignUpWrapper">
            {signType === 'signIn' ? (
                <SignIn isHDD={true} setSignType={setSignType} />
            ) : (
                <SignUp isHDD={true} setSignType={setSignType} />
            )}
        </div>
    );
}
